<template>
    <v-card color="primary">
        <div style="margin: 0 auto; max-width: 80%">
            <hr>
        </div>
        <v-container style="text-align: center">
            <v-layout row wrap justify-center align-center>
                <v-layout row wrap justify-center align-center style="max-width: 800px;">
                    <v-flex xs12 class="overview-headline" style="font-weight: 900">
                        Plugins Tailored To Your Business
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-layout row wrap justify-center align-center class="overview-icons-container">
                <v-flex xs12 sm3 class="px-4 mb-4" style="height: 150px">
                    <v-icon class="overview-icons">mdi-bread-slice</v-icon>
                    <div class="overview-icons--text"><b>Sales Order System</b></div>
                    <div class="overview-icons--text2">Supervise production and sales with an intuitive order managing
                        system.
                    </div>
                </v-flex>

                <v-flex xs12 sm3 class="px-4 mb-4" style="height: 150px">
                    <v-icon class="overview-icons">insert_chart_outlined</v-icon>
                    <div class="overview-icons--text">
                        <b>Client Login</b>
                    </div>
                    <div class="overview-icons--text2">Allow clients to login and interact with documents and the sales
                        order system.
                    </div>
                </v-flex>

                <v-flex xs12 sm3 class="px-4 mb-4" style="height: 150px">
                    <v-icon class="overview-icons">calendar_today</v-icon>
                    <div class="overview-icons--text"><b>Calendars & Appointments</b></div>
                    (coming soon)
                </v-flex>

                <v-flex xs12 sm3 class="px-4 mb-4" style="height: 150px">
                    <v-icon class="overview-icons">timeline</v-icon>
                    <div class="overview-icons--text">
                        <b>Project Management</b>
                        <br>
                        (coming soon)
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: "Services"
    }
</script>

<style scoped>

</style>